import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'witness-info',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './witness-info.component.html',
  styleUrl: './witness-info.component.css'
})
export class WitnessInfoComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() witnessInterviewData: any;
  @Output() onSaveSection1 = new EventEmitter<any>();

  @ViewChild('datepickerInterviewDate') datepickerInterviewDate!: ElementRef;
  witnessInfoForm: FormGroup = new FormGroup([]);

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['witnessInterviewData'] && this.witnessInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.witnessInfoForm = new FormGroup({
      witness_interviewed: new FormControl(this.witnessInterviewData?.witness_interviewed || '', Validators.required),
      date_interview: new FormControl(this.witnessInterviewData?.date_interview || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), Validators.required),
      time_interview: new FormControl(this.witnessInterviewData?.time_interview || '11:00', Validators.required),
      person_conducting_interview: new FormControl(this.witnessInterviewData?.person_conducting_interview || '', Validators.required),
    });
  }

  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import the Datepicker to avoid server-side loading
      const { Datepicker } = await import('flowbite-datepicker');
      if (this.datepickerInterviewDate) {
        new Datepicker(this.datepickerInterviewDate.nativeElement, {
          autohide: true,
          format: 'mm/dd/yyyy'
        });
        // set default value to display for incident date
        if (this.witnessInterviewData?.date_interview) {
          // if date_of_incident is available, set it to the datepicker
          this.datepickerInterviewDate.nativeElement.value = DateUtils.formatDateForDisplay(this.witnessInterviewData.date_interview);
        } else {
          // if date_of_incident is not available, set it to the current date
          this.datepickerInterviewDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
        }
        this.datepickerInterviewDate.nativeElement.addEventListener('changeDate', (event: any) => {
          const formattedDate = DateUtils.formatDateForBackend(event.target.value);
          this.witnessInfoForm.get('interview_date')?.setValue(formattedDate);
        });
      }
    }
  }

  saveWitnessInfo(): void {
    if (this.witnessInfoForm.valid) {
      this.onSaveSection1.emit(this.witnessInfoForm.value);
    }
  }

}
